import type moment from 'moment'

import { observer } from 'mobx-react'

import type { Shift } from 'modules/shift_management/lib/types'

import DisabledNightShiftItem from './ShiftCell/DisabledNightShiftItem'

interface DisabledNightShiftProps {
  date: moment.Moment
  nightShiftsPeriodBefore: Shift[]
}

const DisabledNightShiftCell = ({ date, nightShiftsPeriodBefore }: DisabledNightShiftProps) => {
  return (
    <>
      {!!nightShiftsPeriodBefore &&
        nightShiftsPeriodBefore.map((nightShift) => (
          <DisabledNightShiftItem
            key={`NightShiftCell-${nightShift.id}-index`}
            nightShift={nightShift}
            date={date}
          />
        ))}
    </>
  )
}

export default observer(DisabledNightShiftCell)
